export default __webpack_public_path__ + "static/media/IMG_20230720_075118_142.ea295178.jpg";